export default __webpack_public_path__ + "static/media/icon-white-radio.8a1cd489.png";